export default "\n\n<router-outlet (featureSelected)=\"onNavigate('edit-candidate')\"></router-outlet>\n";